module.exports = __webpack_public_path__ + "img/hand-holding-box.bc6c5ef4.svg";